import axios from 'axios'
import constants from "../constants"

export default { 
  api: axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    withCredentials: true,
    headers: {
      Accept: "application/json"
    }
  }),

  updateAuthentification(authType, token) {
    if (authType == constants.AUTH_TYPE.SPECIF) {
      this.api.defaults.headers.common = {
        Authorization: constants.AUTH_TYPE.SPECIF + " " + token
      }
    } else if (authType == constants.AUTH_TYPE.EUDO_API) {
      this.api.defaults.headers.common = {
        [constants.AUTH_TYPE.EUDO_API]: token
      }
    }
  }
}